import * as React from 'react';
import Divider, { type DividerProps } from '@mui/material/Divider';

export type ListDividerProps = DividerProps & {
  /** react-toolbox: inset divider */
  inset?: boolean;
};

/**
 * ListDivider wrapper - MUI Divider with component="li" for use in lists
 */
const ListDivider = React.forwardRef<HTMLHRElement, ListDividerProps>(({ inset, ...rest }, ref) => {
  return <Divider ref={ref} component="li" variant={inset ? 'inset' : 'fullWidth'} {...rest} />;
});

ListDivider.displayName = 'ListDivider';

export default ListDivider;
